import { render } from "./ProjectArchive.vue?vue&type=template&id=6149c034"
import script from "./ProjectArchive.vue?vue&type=script&lang=js"
export * from "./ProjectArchive.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1363183126/src/dev-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__